export const sectionRouteName = {
  index: "sections.index",
};

export const sectionRoute = [
  {
    path: "/sections",
    name: sectionRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "section",
      breadcrumbs: () => {
        return [{ title: "Section" }];
      },
    },
  },
];
